import { render, staticRenderFns } from "./applicationsChangeBlock.vue?vue&type=template&id=2686b81c&scoped=true&"
import script from "./applicationsChangeBlock.vue?vue&type=script&lang=js&"
export * from "./applicationsChangeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686b81c",
  null
  
)

export default component.exports